

















































































import DropAreaMulti from "@/components/files/DropAreaMulti.vue";
import InvoicePartySheet from "@/components/invoice/InvoicePartySheet.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { IReference } from "@/models/reference.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { BackendResourceEnum } from "@/store/enum/authResourceEnum";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({
  components: { DropAreaMulti, InvoicePartySheet },
  filters: {}
})
export default class ReportClearanceApprovalUpdateStatusDialog extends mixins(PermissionMixin, RulesMixin)
  implements IDialog {
  readonly RequestStatusEnum = RequestStatusEnum;
  @Prop({ default: false }) value!: boolean;
  @Prop({ default: false }) clearanceApproval!: IClearanceApproval;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  status: RequestStatusEnum | null = null;
  requestsLoading = false;

  answerFile: File | null = null;
  get answerFiles(): File[] {
    return this.answerFile ? [this.answerFile] : [];
  }
  set answerFiles(files: File[]) {
    this.answerFile = files.length > 0 ? files[0] : null;
  }

  async save() {
    this.requestsLoading = true;

    if (this.status === null || this.status === undefined) {
      return;
    }
    try {
      const refs: IReference[] = [
        { refType: BackendResourceEnum.CLEARANCE_APPROVAL, refId: this.clearanceApproval.id }
      ];
      if (this.clearanceApproval.reportId) {
        refs.push({ refType: BackendResourceEnum.REPORT, refId: this.clearanceApproval.reportId });
      }

      let signDocument: ISignDocument | undefined;
      if (this.answerFile) {
        const signDocument = new SignDocument({
          name: this.answerFile.name,
          title: this.answerFile.name,
          isTemplate: false,
          folder: BackendResourceEnum.CLEARANCE_APPROVAL,
          refs: refs,
          file: this.answerFile,
          partnerId: this.clearanceApproval.partnerId
        });

        await signDocument.create();
      }

      await this.clearanceApproval.updatePartial({
        status: this.status,
        documentId: signDocument ? signDocument.id : undefined
      });

      this.close();
    } finally {
      this.requestsLoading = false;
    }
  }

  open() {
    this.dialog = true;
  }

  close() {
    this.dialog = false;
  }
}
